export const DEFAULT_FORMAT_FALLBACK = '—';
export const FORMAT_PART_SEPARATOR = '\u00A0';

export const currencyLabels: Record<string, string> = {
  CN: '¥',
  CNY: '¥',
  EUR: '€',
  RMB: '¥',
  RUB: '₽',
  USD: '$'
};

export const fileSizeUnitLabels: Record<string, string> = {
  B: 'B',
  KB: 'KB',
  MB: 'MB'
};

export const pluralCountLabels = {
  box: ['короб', 'короба', 'коробов'],
  incident: ['инцидент', 'инцидента', 'инцидентов'],
  order: ['заказ', 'заказа', 'заказов'],
  payment: ['платеж', 'платежа', 'платежей'],
  point: ['точка', 'точки', 'точек'],
  position: ['позиция', 'позиции', 'позиций'],
  position_dative: ['позиции', 'позициям', 'позициям'],
  position_genitive: ['позиции', 'позиций', 'позиций'],
  shipment: ['поставка', 'поставки', 'поставок'],
  task: ['задача', 'задачи', 'задач']
} as const;

export const unitLabels: Record<string, string> = {
  g: 'г',
  kg: 'кг',
  m3: 'м³',
  pcs: 'шт.',
  sku: 'SKU',
  units: 'ед'
};